module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAgklEQVR4AWMYHOCcoNp/cvAgMuA/DvD3z/f/v769xiWN34CPz4//f3F9wf+3D7f/f35tLsgwkgwAa766Lej/o3Pd/y9v8f3/59cX0gx4eWs5WPPTS1P+PzjV/P/X9zckGQDU8Pr/+ycH/r+5v/n/17dX/v/79webAQgzyMIDb8DwAADQU4sacG1udQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/EG.png
// module id = 1130
// module chunks = 0